import { getAllFlags } from './featureFlags/featureFlags';

/**
 * `blockoutFeature.isRenameLabelsToBlockoutNight`. Until that variation is
 * true, existing "Block Out Dates" copy stays.
 */
export const isBlockOutNightsEnabled = (): boolean =>
  getAllFlags().blockoutFeature?.isRenameLabelsToBlockoutNight === true;

/**
 * Translation key under `common.BLOCKOUT_DATES`, or its `NIGHTS` mirror when
 * the rename flag is on. Both trees in `data/translations/en.ts` share leaves.
 */
export const blockOutKey = (leaf: string): string => {
  const path = isBlockOutNightsEnabled() ? `NIGHTS.${leaf}` : leaf;
  return `common.BLOCKOUT_DATES.${path}`;
};
